module.exports = __webpack_public_path__ + "media/images/area/icon_weather_1-b6be3c9245124ace75ae23cdacac30d1.png";